// The internal-traffic switch, read from inside the app.
//
// The switch itself is an inline script in index.html: it strips `?internal=`
// before the router reads the URL and shows its confirmation without waiting
// for the bundle. This file is the same flag seen from React, so the admin
// readout and the `?internal=1` link can never drift apart: both sides go
// through the one key the consent runtime reads before it lets GA send.

import { TRACKED_HOSTS } from './analyticsConfig';
import { safeStorage } from './safeStorage';

/** The key the consent runtime reads before Google Analytics or Metricool may send. */
export const INTERNAL_TRAFFIC_KEY = 'analytics.disabled';

/** True when this browser is excluded from analytics. */
export function isInternalTraffic(): boolean {
  // Any non-empty value counts, the way the inline switch writes it.
  return Boolean(safeStorage.getItem(INTERNAL_TRAFFIC_KEY));
}

/**
 * Set the flag and report what actually stuck. A browser with storage blocked
 * silently keeps counting, so the caller gets the truth rather than its wish.
 * The caller tells the runtime (`refreshTracking`) so the change takes on this
 * page rather than from the next one.
 */
export function setInternalTraffic(excluded: boolean): boolean {
  if (excluded) {
    safeStorage.setItem(INTERNAL_TRAFFIC_KEY, '1');
  } else {
    safeStorage.removeItem(INTERNAL_TRAFFIC_KEY);
  }
  return isInternalTraffic();
}

/** The hosts the trackers run on. */
export function trackedDomains(): string[] {
  return [...TRACKED_HOSTS];
}

/** Whether this host is one the trackers run on at all. */
export function hostIsTracked(): boolean {
  if (typeof window === 'undefined') return false;
  return TRACKED_HOSTS.includes(window.location.hostname);
}
